'use client';

import { css } from '@linaria/core';

export const title = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
